let count = 0;
export default function getKey() {
	let k = Math.random() + count++;
	return k.toString();
}
